<div class='dashboard-layout-container'>
  <app-navigation-bar *ngIf='this.isNavigationBarDisplayed' />
  <app-navigation-bar-back
    *ngIf='this.isNavigationBarBackDisplayed'
    [previousPageUrl]='this.previousUrl'
  />
<!--  <app-portal-data-element-list-indicator
    *ngIf='this.isPortalDataIndicatorDisplayed'></app-portal-data-element-list-indicator>
  <app-portal-data-dashboard-global-indicator-bar
    *ngIf='this.isPortalDataDashboardGlobalIndicatorDisplayed'></app-portal-data-dashboard-global-indicator-bar>-->
  <app-navigation-tabs *ngIf='this.isNavigationTabsDisplayed' />
  <div style='height: 100%'>
    <ng-content></ng-content>
  </div>
</div>
